// extracted by mini-css-extract-plugin
export default {"headingDiv":"AssignmentHeading_headingDiv__SvXHZ"};